import React from 'react';

interface Props{
}
const HealthCheckContainer: React.FC<Props> = ({}) => {

  return (
    <div className="health-check template">
        <article className="template-circle-header health-check__ template-circle-header--secondary">
          <div className="template-circle-header__content">
              <div className="template-circle-header__content-copy">
                  <h1 className="template-element-title--header promise">
                      Your Puppy’s Health is Everything
                  </h1>
                                                                  <p style={{margin: '1.2rem 0'}}>We’re dedicated to ensuring your new companion arrives healthy, happy, and ready for cuddles. Our independent Scientific Advisory Board, comprised of national experts in puppy and animal care, guides our health protocols, setting the highest standards for safety and welfare. Additionally, our 10-Year Health Commitment offers peace of mind, with comprehensive coverage for any health concerns as long as dog insurance is in place.</p>
                                                      </div>
              <picture className="">
                          <img id="" alt="" className="template-circle-header__image lazyloaded" data-cy="" data-src="https://cdn.buttercms.com/5Qv7C0UXSlq8Vlo4Wegy" loading="lazy" src="https://cdn.buttercms.com/5Qv7C0UXSlq8Vlo4Wegy"/>
              </picture>

          </div>
      </article>
              <article className="about-navigation">
          <a className="" href="/promise">PuppySpot Promise</a>
          <a className="" href="/reviews">Customer Reviews</a>
          <a className="" href="/puppyspot-standards">Breeder Standards</a>
          <a className="active" href="/health-check">Health Check</a>
          <a className="" href="/dog-travel">Travel Options</a>
          <a className="" href="/gives-back">PuppySpot Gives Back</a>
      </article>
              <article>
                  <h2 className="logline">Every puppy receives a nose-to-tail health check before coming home. </h2>
              </article>
              <article className="template-image-copy image-left overlapped health-check__primary-concern" id="primary-concern">
          <div className="template-image-copy__content">
                          <div style={{backgroundImage: "url('https://cdn.buttercms.com/sa72G957TqWlH2O825uL')"}} className="template-image-copy__image health-check__primary-concern-image"></div>
                      <div className="template-image-copy__copy health-check__primary-concern-copy">
                                  <h2 className="template-element-title ">
                                              Puppy health begins at our breeders' homes
                      </h2>
                                                                              <p className="template-copy">
                              The environment that a newborn puppy experiences is critical. That’s why PuppySpot has developed the most exacting standards of breeder care in the industry. Our breeders go above and beyond to create environments that are clean, comfortable, and spacious, allowing each puppy to wean, sleep and explore their new world in peace. After a breeder has been accepted into our program all of their puppies must pass our comprehensive health evaluations by a licensed veterinarian prior to delivery.

                          </p>
                                                      </div>
          </div>
      </article>
              <article className="template-image-copy image-left overlapped health-check__health-evaluations" id="health-evaluations">
          <div className="template-image-copy__content">
                          <div style={{backgroundImage: "url('https://cdn.buttercms.com/7hbeZtLuSHG2RMxR3QjQ')"}} className="template-image-copy__image health-check__health-evaluations-image"></div>
                      <div className="template-image-copy__copy health-check__health-evaluations-copy">
                                  <h2 className="template-element-title ">
                                              Our comprehensive health evaluation
                      </h2>
                                                                              <p>Every PuppySpot certified Breeder Partner is required to keep their puppies up-to-date on all vaccinations and deworming regimens. 48 hours prior to delivery each newly adopted puppy must pass a “nose to tail” health evaluation conducted by the Breeder Partner’s licensed veterinarian. The evaluation consists of a thorough examination of a puppy’s ears, eyes, mouth, teeth, gums, respiratory system, cardiovascular system, musculoskeletal system, skin and coat, gastrointestinal system, and external genitalia. The veterinarian is looking for common conditions like conjunctivitis and parasites and far less common indicators of possible congenital issues. The results of the evaluation are then reported through our mandatory Veterinary Health Report (VHR)</p>
                                                      </div>
          </div>
      </article>
              <article>
                  <h2 className="logline">We are committed to the health of your puppy</h2>
              </article>
              <article className="template-image-copy image-left overlapped health-check__health-guarantee" id="health-guarantee">
          <div className="template-image-copy__content">
                          <div style={{backgroundImage: "url('https://cdn.buttercms.com/9r4E9ygfQHCeji3ksqf9')"}} className="template-image-copy__image health-check__health-guarantee-image"></div>
                      <div className="template-image-copy__copy health-check__health-guarantee-copy">
                                  <h2 className="template-element-title ">
                                              Your commitment to your puppy’s health
                      </h2>
                                                                              <p>When you adopt a puppy through us, you effectively become our partner in caring for these little puppies for life. It’s part of the reason that we require you to take out pet health insurance and strongly encourage all new owners to take their pup to the vet as soon as possible. No matter how smoothly the transition goes, having your puppy checked by a vet right away is both the healthy and responsible thing to do.</p>
                                                      </div>
          </div>
      </article>
              <section className="template-title-copy template-icon-grid--health-check">
          <article>
              <h2>Our 10-year health commitment </h2>
              <div className="template-title-copy__content">
                  <p>Adopting a PuppySpot puppy means committing to its lifelong care, including regular vet visits and associated costs. While we take every measure to ensure your puppy is healthy at the time of delivery, health issues can arise over time. That's why we offer our 10-Year Health Commitment, which covers any PuppySpot puppy delivered and continuously residing in the U.S. or Canada. For full details, please review the Terms and Conditions of the 10-Year Health Commitment. Here’s a brief summary:</p>
              </div>
          </article>
      </section>
              <article className="template-icon-grid template-icon-grid--health-check health-check__">
                  <div className="template-icon-grid__card">
                  <picture className="">
                          <img id="" alt="" className="lazyload " data-cy="" data-src="https://cdn.buttercms.com/8IDMsaGbRT2KXDKSYT9V" loading="lazy"/>
              </picture>

                  <div className="template-icon-grid__card-copy">
                      <h3 id="template-icon-grid__1-week">
                          Days 1-14 after delivery of your puppy
                      </h3>
                      <div role="definition" aria-labelledby="template-icon-grid__1-week">
                          <p>If your puppy is found to have a contagious disease, illness, or parasite, PuppySpot will provide you with reimbursement of reasonable and customary veterinary bills to treat such condition up to the purchase price of your puppy.</p>
                      </div>
                  </div>
              </div>
                  <div className="template-icon-grid__card">
                  <picture className="">
                          <img id="" alt="" className="lazyload " data-cy="" data-src="https://cdn.buttercms.com/SLyCEPiZQwGzRUk1nY2A" loading="lazy"/>
              </picture>

                  <div className="template-icon-grid__card-copy">
                      <h3 id="template-icon-grid__1-year">
                          Days 1-365 (first year) after delivery of your puppy
                      </h3>
                      <div role="definition" aria-labelledby="template-icon-grid__1-year">
                          <p>If your dog is found and certified to have a congenital or hereditary condition which adversely affects the health of the dog by a major insurance provider, PuppySpot will provide reimbursement of reasonable, documented, insurance deductible and copays.&nbsp;&nbsp;</p>
      <p><br /><br /></p>
                      </div>
                  </div>
              </div>
                  <div className="template-icon-grid__card">
                  <picture className="">
                          <img id="" alt="" className="lazyload " data-cy="" data-src="https://cdn.buttercms.com/pQoKhOaSuyWYJeD6gHZq" loading="lazy"/>
              </picture>

                  <div className="template-icon-grid__card-copy">
                      <h3 id="template-icon-grid__2-years">
                          Years 2-10 after delivery of your puppy
                      </h3>
                      <div role="definition" aria-labelledby="template-icon-grid__2-years">
                          <p>For all breeds EXCEPT English Bulldogs, if your dog is found and certified by two licensed veterinarians to have a congenital or hereditary condition which adversely affects the health of your dog, PuppySpot shall either issue a credit toward the purchase of another PuppySpot puppy in the amount of reasonable, documented, actually incurred veterinary expenses associated with such diagnosed condition amounting up to fifty percent of the purchase price of your puppy or, if you choose, a direct reimbursement of such amounts up to twenty-five percent of the purchase price of your puppy.&nbsp;</p>
      <p><br /><br /></p>
                      </div>
                  </div>
              </div>
              <div className="template-icon-grid__blurb">
                          <p className="text-center">
                      <a href="/terms-and-conditions-of-commitment" target="_self" className="arrow">
                          Click here to read the full terms and conditions of PuppySpot’s health commitment.
                      </a>
                  </p>
                  </div>
      </article>
              <article>
                  <h2 className="logline">Our independent Scientific Advisory Board sets the standards our whole company follows. </h2>
              </article>
              <article className="template-image-copy image-left full-half health-check__health-team" id="health-team">
          <div className="template-image-copy__content">
                          <div style={{backgroundImage: "url('https://cdn.buttercms.com/jZVnSrcgTpONovri7x8I')"}} className="template-image-copy__image health-check__health-team-image"></div>
                      <div className="template-image-copy__copy health-check__health-team-copy">
                                  <h2 className="template-element-title ">
                                              The PuppySpot Health Team
                      </h2>
                                                                              <p className="template-copy">
                              Our PuppySpot Health Team is comprised of experts on puppy and adult dog care dedicated to ensuring the safety and welfare of your puppy.
                          </p>
                                                      </div>
          </div>
      </article>
    </div>
  );
}

export default HealthCheckContainer;
